export const findFirstMatchIndex = (
  array: string[],
  list?: { amount: number; reason?: string }[] | null
): number => {
  if (!array || !list) return 0

  const index = array.findIndex((searchString) =>
    list.some((item) => item.reason === searchString)
  )
  return index !== -1
    ? list.findIndex((item) => item.reason === array[index])
    : 0
}
